import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SoftwarePlanModal } from '@thinknet-gmbh/platform-common-ui';

import { PaymentModal } from 'src/components/payment-modal/';
import { useGetSoftwarePlansForModule } from 'src/hooks/software-plan/get-software-plans.hook';
import { useAuth } from 'src/hooks/auth.hooks';

import { ISubscribeInfo } from './software-plans-modal.interfaces';
import { SUBSCRIBE_INFO_DEFAULT_VALUE } from './software-plans-modal.constants';

const SoftwarePlansModal = ({
  subscriptionId,
  usedEmployeesPlacesCount,
}: {
  subscriptionId: string;
  usedEmployeesPlacesCount: number;
}) => {
  const { t } = useTranslation('dashboard');
  const [subscribeInfo, setSubscribeInfo] = useState<ISubscribeInfo>(SUBSCRIBE_INFO_DEFAULT_VALUE);
  const { softwarePlans, loading } = useGetSoftwarePlansForModule();
  const { logout } = useAuth();
  const [isPaymentStage, setIsPaymentStage] = useState(false);
  const customerNumber = usedEmployeesPlacesCount > 1 ? usedEmployeesPlacesCount : 0;

  return (
    <>
      {!isPaymentStage && (
        <SoftwarePlanModal
          loading={loading}
          isOpened={!isPaymentStage}
          onFinish={selectedSubscribeInfo => {
            setSubscribeInfo(selectedSubscribeInfo);
            setIsPaymentStage(true);
          }}
          softwarePlans={softwarePlans}
          minCustomerNumber={customerNumber}
          initialsSubscribeInfo={{
            ...subscribeInfo,
            ...(customerNumber && { customerNumber }),
          }}
          t={t}
          logout={logout}
        />
      )}
      {isPaymentStage && (
        <PaymentModal
          isOpened
          title={t('labels.addCard')}
          onClose={() => setIsPaymentStage(false)}
          subtitle={t('labels.addCardDescription')}
          subscribeInfo={{ subscriptionId, ...subscribeInfo }}
        />
      )}
    </>
  );
};

export default SoftwarePlansModal;
